import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText/FormHelperText";

const CoreSelect = ({ items = [], helperText, ...props }) => {
  const itemList = Object.keys(items).map((item) => (
    <MenuItem key={item} value={items[item]}>
      {items[item]}
    </MenuItem>
  ));

  return (
    <div className={props.className}>
      <FormControl
        fullWidth
        size="small"
        disabled={props.disabled}
        error={props.error}
        required={props.required}
      >
        <InputLabel>{props.label}</InputLabel>
        <Select
          
          defaultValue={props.defaultValue}
          label={props.label}
          {...props}
        >
          {itemList}
        </Select>
        <FormHelperText>{props.error ? helperText : ""}</FormHelperText>
      </FormControl>
    </div>
  );
};

export default CoreSelect;
